// Keeps the Applications page running once it has been opened, whichever
// panel is showing (plan phase 5, 2026-09-28).
//
// That page is also the engine of auto-apply: it hears the extension, sends
// ready runs out on their own, and watches a live fill. Mounted only while its
// panel was open, all of that stopped the moment the person looked at Jobs or
// their resume, and ready runs sat at Ready. So one copy is kept mounted in a
// node of its own, and the node is moved: into the panel while Applications is
// open, into a hidden holder when it is not. React never remounts it, so there
// is exactly one owner of every listener, and the work never runs twice.
import React, { Suspense, lazy, useLayoutEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import ErrorBoundary from '../ErrorBoundary';
import RequireResume from '../RequireResume';

const JobAgent = lazy(() => import('../JobAgent/JobAgent'));

export default function ApplicationsKeeper({ active, host, holder }) {
  const node = useMemo(() => {
    const el = document.createElement('div');
    el.className = 'shell-keep';
    return el;
  }, []);

  useLayoutEffect(() => {
    const parent = active && host ? host : holder;
    if (parent && node.parentNode !== parent) parent.appendChild(node);
  }, [active, host, holder, node]);
  useLayoutEffect(() => () => { node.remove(); }, [node]);

  return createPortal(
    <ErrorBoundary>
      <Suspense fallback={null}>
        <RequireResume><JobAgent active={active} /></RequireResume>
      </Suspense>
    </ErrorBoundary>,
    node,
  );
}
